import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, HateoasMultipleResponseObject } from '@scisys-uim/uim-common';
import { BusinessUnit } from 'assets-model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class TodolistService {

  public TODOLIST_API;

  constructor(public http: HttpClient, @Inject(ENVIRONMENT) private environment: any) {
    this.TODOLIST_API = this.environment.apiUrl + "/todo/";
  }

  public getTodoList(): Observable<HateoasMultipleResponseObject<TodolistEntry>> {
    return this.http.get<HateoasMultipleResponseObject<TodolistEntry>>(this.TODOLIST_API + "all");
  }

  public toggleComplete(id): Observable<any> {
    return this.http.patch(this.TODOLIST_API + id + "/complete", {});
  }

  public addEntry(entry: TodolistEntry): Observable<any> {
    return this.http.put(this.TODOLIST_API + "add", entry);
  }

  public removeEntry(id: string): Observable<any> {
    return this.http.delete(this.TODOLIST_API + id + "/delete", {});
  }
}

export class TodolistEntry {
  id: string;
  name: string;
  description: string;
  businessUnit: BusinessUnit;
  markedNational: boolean;
  dueDate: Date;
  completedDate: Date;
  completed: boolean;
  parent: TodolistEntry;
  parentId: number;
  children: TodolistEntry[];
  numCompleted: number;

  constructor(name: string, dueDate: Date, description: string, businessUnit: BusinessUnit, national: boolean) {
    this.id = null;
    this.name = name;
    this.description = description;
    this.businessUnit = businessUnit;
    this.markedNational = national;
    this.dueDate = dueDate;
    this.completedDate = null;
    this.completed = false;
  }


}

export function calculateNumCompleted(entry: TodolistEntry) {
  var num = 0;
  for (let child of entry.children) {
    if (child.completed) {
      num += 1;
    }
  }
  return num;
}
